import { useTranslation } from 'react-i18next';
import { Globe } from '@phosphor-icons/react';
import { useTheme } from '@/contexts/ThemeContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const LANGUAGES = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' }
];

export default function LanguageSelector({ compact = false }) {
  const { i18n } = useTranslation();
  const { isDark } = useTheme();
  const currentLang = i18n.language?.split('-')[0] || 'fr';

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('simblyo_language', langCode);
  };

  if (compact) {
    return (
      <button
        onClick={() => handleLanguageChange(currentLang === 'fr' ? 'en' : 'fr')}
        className={`p-2 rounded-lg transition-colors ${
          isDark 
            ? 'hover:bg-white/10 text-white/70' 
            : 'hover:bg-gray-100 text-gray-600'
        }`}
        title={currentLang === 'fr' ? 'Switch to English' : 'Passer en Français'}
        data-testid="language-toggle"
      >
        <span className="text-lg">
          {LANGUAGES.find(l => l.code === currentLang)?.flag || '🌐'}
        </span>
      </button>
    );
  }

  return (
    <Select value={currentLang} onValueChange={handleLanguageChange}>
      <SelectTrigger 
        className={`w-[140px] ${isDark ? 'bg-white/[0.03] border-white/[0.08]' : ''}`}
        data-testid="language-selector"
      >
        <div className="flex items-center gap-2">
          <Globe size={16} />
          <SelectValue />
        </div>
      </SelectTrigger>
      <SelectContent>
        {LANGUAGES.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            <span className="flex items-center gap-2">
              <span>{lang.flag}</span>
              <span>{lang.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
